module.exports = __webpack_public_path__ + "img/confuse.a9811464.png";